import { html } from "lit-html";
import { OrangeBookJsEnv } from "../../../models/orange_book/orange_book_js_env";
import { OrangeBookArea } from "./orange_book";

export const OrangeBookBody = (model: OrangeBookJsEnv) => html`
${OrangeBookArea(model)}
`;
